export * from './models/note.model';
export * from './texts/notes.texts';
